import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

type MembershipStatus = {
  isAdmin: boolean;
  isPremium: boolean;
  isPermanent: boolean;
  premiumUntil: string | null;
};

export function useMembershipStatus(userId?: string) {
  return useQuery({
    queryKey: ["membership-status", userId],
    enabled: !!userId,
    queryFn: async (): Promise<MembershipStatus> => {
      const [{ data: isAdmin }, { data: isPremium }] = await Promise.all([
        supabase.rpc("has_role", { _user_id: userId, _role: "admin" }),
        supabase.rpc("has_role", { _user_id: userId, _role: "premium" }),
      ]);

      const admin = !!(isAdmin as any);
      const premium = admin || !!(isPremium as any);

      if (!premium) {
        return { isAdmin: false, isPremium: false, isPermanent: false, premiumUntil: null };
      }

      const { data, error } = await supabase
        .from("cdk_codes")
        .select("premium_until,is_used,used_by")
        .eq("is_used", true)
        .eq("used_by", userId);

      if (error) {
        return { isAdmin: admin, isPremium: premium, isPermanent: false, premiumUntil: null };
      }

      const rows = data || [];
      const isPermanent = rows.some((r: any) => r.premium_until === null);
      if (isPermanent) return { isAdmin: admin, isPremium: premium, isPermanent: true, premiumUntil: null };

      const maxUntil = rows
        .map((r: any) => r.premium_until)
        .filter(Boolean)
        .sort()
        .slice(-1)[0] as string | undefined;

      return { isAdmin: admin, isPremium: premium, isPermanent: false, premiumUntil: maxUntil || null };
    },
  });
}

